module.exports = __webpack_public_path__ + "static/media/camel.23daff40.png";